import type { DaturaImportJobObjects200Response } from 'farmdok-rest-api';
import Vue from 'vue';
import type { ActionContext } from 'vuex';

import { Api } from '@/plugins/farmdokRestApi';
import { ApiResponse } from '@/shared/api/farmdokRestApi/types';
import subscribableData from '@/shared/mixins/store/subscribableData/index';
import { SubscribableDataState } from '@/shared/mixins/store/types';
import type { RootState } from '@/store/types';

import { DaturaHistoryEntry } from './types';

export async function fetchAll({
  rootGetters,
}: ActionContext<SubscribableDataState<DaturaHistoryEntry>, RootState>): Promise<ApiResponse<DaturaHistoryEntry>> {
  const { daturaApi } = Vue.prototype.$api as Api;
  const processOrderId = rootGetters['auth/currentProcessOrderIds'][0];
  const promise = await daturaApi.daturaImportJobList({ processOrderId });
  return toApiResponse(promise.data);
}

function toApiResponse(response: DaturaImportJobObjects200Response): ApiResponse<DaturaHistoryEntry> {
  return {
    ...response,
    data: response.data,
  } as ApiResponse<DaturaHistoryEntry>;
}

async function fetchByIds(): Promise<ApiResponse<DaturaHistoryEntry>> {
  throw new Error('Unsupported operation!');
}

export const subscribableStore = subscribableData(fetchAll, fetchByIds);
